import type { TabViewItem } from "@/ui/tab-view";

import { useTranslation } from "react-i18next";

import { TAB_KEYS } from "@/constants/TabKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { PasswordUpdate } from "@/modules/password-update";
import { UserPreferencesNotifications } from "@/modules/user-preferences-notifications";
import { TabView } from "@/ui/tab-view";

import "./preferences-page.style.less";

export const PreferencesPage = () => {
  const { t } = useTranslation();

  const tabs: TabViewItem[] = [
    {
      key: TAB_KEYS.PREFERENCES_NOTIFICATIONS,
      label: t("user:preferences.tabs.notifications.label"),
      children: <UserPreferencesNotifications />,
    },
    {
      key: TAB_KEYS.PREFERENCES_SECURITY,
      label: t("user:preferences.tabs.security.label"),
      children: <PasswordUpdate />,
    },
  ];

  return (
    <AppLayoutPage className="preferences-page">
      <TabView isNav tabs={tabs} alwaysSyncSearchParams />
    </AppLayoutPage>
  );
};
